"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockChatMessage = exports.mockChatMessageThread = void 0;
const src_1 = require("../../src");
const helpers_1 = require("../helpers");
const mockChatMessageThread = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        owner_uid: helpers_1.chance.guid(),
        owner_handle: helpers_1.chance.string(),
        created_at: helpers_1.chance.integer(),
        updated_at: helpers_1.chance.integer(),
        messages: {},
        ...overrides,
    };
};
exports.mockChatMessageThread = mockChatMessageThread;
const mockChatMessage = (overrides) => {
    return {
        uid: helpers_1.chance.guid(),
        belongs_to_thread_uid: helpers_1.chance.guid(),
        owner_uid: helpers_1.chance.guid(),
        owner_handle: helpers_1.chance.string(),
        content: helpers_1.chance.paragraph(),
        // TODO: Make this random, or we should turn this to an arbitrary
        // Right now this is just a fast implementation to unblock an evaluation test we want to add
        meta_data: {
            type: "human",
            selected_model: "gpt-4o",
            editor_mode: src_1.EditorModes.pcb,
            pcb_camera_mode: src_1.CameraMode.two_d,
            reviews: [],
        },
        reply_to_message_uid: helpers_1.chance.string(),
        created_at: helpers_1.chance.integer(),
        updated_at: helpers_1.chance.integer(),
        reactions: {},
        ...overrides,
    };
};
exports.mockChatMessage = mockChatMessage;
//# sourceMappingURL=mockChatData.js.map